export default {"src":"/_next/static/media/corner-50-off.b1508017.svg","height":90,"width":210,"blurWidth":0,"blurHeight":0};